import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const DishwasherIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "DishwasherIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M5.41896 5.87546C5.74256 5.87546 6.0049 5.61313 6.0049 5.28952C6.0049 4.96592 5.74256 4.70358 5.41896 4.70358C5.09535 4.70358 4.83302 4.96592 4.83302 5.28952C4.83302 5.61313 5.09535 5.87546 5.41896 5.87546Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.76271 5.87546C8.08631 5.87546 8.34865 5.61313 8.34865 5.28952C8.34865 4.96592 8.08631 4.70358 7.76271 4.70358C7.4391 4.70358 7.17677 4.96592 7.17677 5.28952C7.17677 5.61313 7.4391 5.87546 7.76271 5.87546Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.1065 5.87546C10.4301 5.87546 10.6924 5.61313 10.6924 5.28952C10.6924 4.96592 10.4301 4.70358 10.1065 4.70358C9.78286 4.70358 9.52052 4.96592 9.52052 5.28952C9.52052 5.61313 9.78286 5.87546 10.1065 5.87546Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.6924 2.35983H4.20802C3.23876 2.35983 2.4502 3.14839 2.4502 4.11765V20.6021C2.4502 21.5713 3.23876 22.3599 4.20802 22.3599H20.6924C21.6617 22.3599 22.4502 21.5713 22.4502 20.6021V4.11764C22.4502 3.14838 21.6617 2.35983 20.6924 2.35983ZM21.2784 20.602C21.2784 20.9251 21.0155 21.188 20.6924 21.188H4.20802C3.88493 21.188 3.62208 20.9251 3.62208 20.602V4.11764C3.62208 3.79455 3.88493 3.5317 4.20802 3.5317H20.6924C21.0155 3.5317 21.2784 3.79455 21.2784 4.11764V20.602Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.4815 7.04733H5.41896C5.09537 7.04733 4.83302 7.30967 4.83302 7.63327V19.3911C4.83302 19.7147 5.09536 19.977 5.41896 19.977H19.4815C19.8051 19.977 20.0674 19.7147 20.0674 19.3911V7.63327C20.0674 7.30968 19.8051 7.04733 19.4815 7.04733ZM10.6924 18.8052C9.72313 18.8052 8.93458 18.0166 8.93458 17.0473C8.93458 16.0781 9.72313 15.2895 10.6924 15.2895C11.6617 15.2895 12.4502 16.0781 12.4502 17.0473C12.4502 18.0166 11.6617 18.8052 10.6924 18.8052ZM14.208 18.8052C13.8569 18.8052 13.5172 18.6996 13.2305 18.5077C13.479 18.0775 13.6221 17.579 13.6221 17.0474C13.6221 16.5158 13.479 16.0172 13.2305 15.587C13.5172 15.3951 13.8569 15.2895 14.208 15.2895C15.1773 15.2895 15.9658 16.0781 15.9658 17.0474C15.9658 18.0166 15.1773 18.8052 14.208 18.8052ZM18.8955 18.8052H16.5502C16.9188 18.3152 17.1377 17.7064 17.1377 17.0473C17.1377 15.4319 15.8235 14.1177 14.208 14.1177C13.569 14.1177 12.953 14.3273 12.4497 14.7048C11.9598 14.3364 11.3512 14.1177 10.6924 14.1177C9.07697 14.1177 7.76271 15.4319 7.76271 17.0473C7.76271 17.7064 7.98158 18.3152 8.35025 18.8052H6.00489V8.21921H18.8955L18.8955 18.8052Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.4502 9.39109C12.1266 9.39109 11.8643 9.65343 11.8643 9.97703V11.1489C11.8643 11.4725 12.1266 11.7349 12.4502 11.7349C12.7738 11.7349 13.0362 11.4725 13.0362 11.1489V9.97703C13.0362 9.65344 12.7738 9.39109 12.4502 9.39109Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.5208 9.56269C10.292 9.33386 9.92095 9.33386 9.69213 9.56269L8.52025 10.7346C8.29142 10.9634 8.29142 11.3344 8.52025 11.5632C8.74904 11.792 9.12009 11.7921 9.34888 11.5632L10.5208 10.3913C10.7496 10.1625 10.7496 9.79151 10.5208 9.56269Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.3802 10.7346L15.2083 9.56268C14.9795 9.33385 14.6085 9.33385 14.3797 9.56268C14.1509 9.79151 14.1508 10.1625 14.3797 10.3913L15.5516 11.5632C15.7803 11.792 16.1514 11.7921 16.3802 11.5632C16.609 11.3344 16.609 10.9634 16.3802 10.7346Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.4815 4.70358H17.1377C16.8141 4.70358 16.5518 4.96592 16.5518 5.28952C16.5518 5.61312 16.8141 5.87546 17.1377 5.87546H19.4815C19.8051 5.87546 20.0674 5.61312 20.0674 5.28952C20.0674 4.96592 19.8051 4.70358 19.4815 4.70358Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default DishwasherIcon;
